<div class="table-container">
  <table *ngIf="excelData && headerColumns.length">
    <!-- Bandeau d'entête : lignes 1 à 3 fusionnées dans l'Excel (A1:A3 / B1:F3 / G1:G3) -->
    <thead>
      <tr>
        <th>
          <span class="fw-semibold">{{ current | uppercase }}</span>
        </th>
        <th [attr.colspan]="headerColumns.length - 2" style="text-align: center; font-size: 15px;">
          {{ excelData[0][1] }}
        </th>
        <th style="text-align: right;">
          {{ excelData[0][headerColumns.length - 1] }}
        </th>
      </tr>

      <!-- Ligne 4 de l'Excel : entêtes des colonnes -->
      <tr class="header-row">
        <th *ngFor="let header of headerColumns">
          {{ header }}
        </th>
      </tr>
    </thead>

    <!-- Données (à partir de la ligne 5, hors "Total" et "Moyenne (DRM)") -->
    <tbody>
      <tr
        *ngFor="let row of dataRows; let i = index"
        [class.selected]="selectedRowIndex === i"
        (click)="selectRow(i)"
      >
        <td
          *ngFor="let cell of row; let j = index"
          class="truncate-cell"
          [class.numeric-cell]="isNumeric(j)"
        >
          {{ isNumeric(j) ? (cell | number:'1.2-2':'fr-FR') : cell }}
        </td>
      </tr>
    </tbody>

    <!-- Total, puis Moyenne (DRM) si présente -->
    <tfoot>
      <tr class="total-row" *ngIf="totalRow">
        <td *ngFor="let cell of totalRow; let j = index" [class.numeric-cell]="isNumeric(j)">
          {{ isNumeric(j) ? (cell | number:'1.2-2':'fr-FR') : cell }}
        </td>
      </tr>
      <tr class="moyenne-row" *ngIf="moyenneRow">
        <td *ngFor="let cell of moyenneRow; let j = index" [class.numeric-cell]="isNumeric(j)">
          {{ isNumeric(j) ? (cell | number:'1.2-2':'fr-FR') : cell }}
        </td>
      </tr>
    </tfoot>
  </table>
</div>